import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import CheckoutPage from "../pages/CheckoutPage";
import ViewTicketsPage from "../pages/ViewTicketsPage";
import PaymentStatusPage from "../pages/PaymentStatusPage";

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route>
            <Route path="/" element={<ViewTicketsPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/paymentstatus" element={<PaymentStatusPage />} />


            <Route path="*" element={<ViewTicketsPage />} />
        </Route>
    ))